import { render } from "./Menus.vue.js?vue&type=template&id=3e8dc4aa!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Menus.vue?vue&type=template&id=3e8dc4aa"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__